import { render, staticRenderFns } from "./SettlementReview.vue?vue&type=template&id=52482b8f"
import script from "./SettlementReview.vue?vue&type=script&lang=js"
export * from "./SettlementReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports